import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Jumbotron from 'react-bootstrap/Jumbotron';
import Button from 'react-bootstrap/Button';
import { LinkContainer } from 'react-router-bootstrap';
import {Container, Row, Col} from 'react-bootstrap'
import "./Hiscore.css";

export default class Hiscore extends Component {
    constructor(props) {
        super(props);
        this.state = {
            points: 0
        }
    }

    componentWillMount() {
        this.locationState = this.props.location.state.points;    // get points props from main component
        console.log("this.locationstate: ", this.locationState)
    }

    render() {
        return (
            <div className="Hiscore">
                {/* <Jumbotron> */}
                    <h3>You scored {this.locationState}/10 points!</h3>
                    <h3>Another round?</h3><br/>
                    <Container>
                        <Row>
                            <Col sm={2} md={3} lg={4}></Col>
                            <Col xs={12} sm={8} md={6} lg={4}>
                                <LinkContainer to={{
                                    pathname: "/main",
                                    state: { diff: 2 }
                                }}
                                >
                                    <Button variant="primary" block>
                                        Easy
                            </Button>
                                </LinkContainer>
                                <LinkContainer to={{
                                    pathname: "/main",
                                    state: { diff: 4 }
                                }}
                                >
                                    <Button variant="danger" block>
                                        Hard
                            </Button>
                                </LinkContainer>
                                <LinkContainer to={{
                                    pathname: "/main",
                                    state: { diff: 19 }
                                }}
                                >
                                    <Button variant="dark" block>
                                        Impossible
                            </Button>
                                </LinkContainer>
                            </Col>
                        </Row>
                    </Container>
                {/* </Jumbotron> */}
            </div>
        )
    }
}
